import React, { Component } from "react";
import Icons from "../../icon";
export class TabberButton extends Component {
    constructor(props) {
        super(props);
        this.state={
            active: false
        }
        this.onClickTabber=this.onClickTabber.bind(this);
    }
    onClickTabber() {
        const { onToggle } = this.props;

        var isActive = !this.state.active;
        this.setState({ active: isActive })

        if (onToggle) {
            onToggle(isActive);
        }
    }

    tabActive = () => {
        return this.state.active;
    }

    toggle(isActive) {
        const { onToggle } = this.props;
        this.setState({ active: isActive });

        if (onToggle) {
            onToggle(isActive);
        }
    }

    render(){
        const { title } = this.props;
        return (
            <div className={`tabber-layout-container`}>
                <h1 className="title">{title && title}</h1>
                <div className="tabber-container">
                    <div className={`tabber-inner-container ${this.state.active ? 'tabber-active' : null}`} onClick={this.onClickTabber}>
                        <div className="tabber-container-circle">
                        {this.state.active &&
                            <Icons
                                customClassName="icon-check-reg"
                                name="check"
                                size="16px"
                                containerClass="icon-circle-plus-container"
                            /> 
                        }
                        </div>										
                    </div>
                    <span className={`${this.state.active ? 'tabber-label-active' : 'tabber-label-off'}`}>{this.props.label}</span>
                </div>
            </div>
        );
    }
}